<script lang="ts">
import ClientStateFilterList from '../components/ClientStateFilterList.vue';

/** Orders list. Client-side state filtering - see ClientStateFilterList. */
export default { name: 'ListCertManagerOrder', extends: ClientStateFilterList };
</script>
